import { FunctionComponent, ReactElement } from 'react'
import { Link as ReactLink, useLocation } from 'react-router-dom'
import styles from './link.module.scss'
import { Typography } from '@mui/material'
import { Browser } from '@capacitor/browser'

interface LinkProps {
    href: string
    className?: string
    target?: string
    children: ReactElement | ReactElement[]
    classText?: string
    underline?: boolean
}

const Link: FunctionComponent<LinkProps> = ({
    href,
    target = '_self',
    className,
    children,
    classText,
    underline = false
}: LinkProps) => {
    const { pathname } = useLocation()

    return (
        ((target === '_blank' || !href.startsWith('/')) && (
            <a
                className={`${className}`}
                onClick={() => {
                    Browser.open({
                        url: href,
                        windowName: target
                    })
                }}
            >
                <Typography component={'span'} className={`${classText} ${underline ? styles.Text : ''}`}>
                    {children}
                </Typography>
            </a>
        )) || (
            <ReactLink
                className={`${className}`}
                target={target}
                to={pathname === href && target === '_self' ? '#' : href}
            >
                <Typography component={'span'} className={`${classText} ${underline ? styles.Text : ''}`}>
                    {children}
                </Typography>
            </ReactLink>
        )
    )
}

export default Link
